import React, { useEffect, useState } from 'react';
import AppointmentView from './View';
import useCollaborative from '../../../../../hooks/api/useCollaborative';
import { useRecoilState } from 'recoil';
import { appointmentState } from '../../../../../recoil/selectors/appointments';
import { CircularProgress } from '@material-ui/core';

const AppointmentViewContainer = ({ match, history, ...props }) => {
  const { id } = match.params;

  const { getAppointment } = useCollaborative();
  const [appointmentLoading, setAppointmentLoading] = useState(false);
  const [appointment, setAppointment] = useRecoilState(appointmentState(id));

  useEffect(() => {
    if (id) {
      setAppointmentLoading(true);
      getAppointment(id)
        .then((appointment) => {
          setAppointmentLoading(false);
          setAppointment(appointment);
        })
        .then((error) => {
          setAppointmentLoading(false);
        });
    }
  }, [id]);

  if (appointmentLoading) {
    return <CircularProgress size={15} />;
  }

  if (!appointment) {
    return null;
  }

  return <AppointmentView appointment={appointment} {...props} />;
};

export default AppointmentViewContainer;
